
<template>
	<div>
		<compWrapper :title="$t('fbb.accountmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
			<!-- <compFormQuery class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery> -->
            <compFormEdit ref="saveForm" class="margin-layout" :formdata="getBase" v-model="inputData" :rules="formRules"></compFormEdit>
            <div v-if="temptype == 4" class="button-container">
                <Button class="margin-right-15" type="primary" @click="saveOne">{{$t('global.common.save', { defaultValue: '保存' })}}</Button>
                <Button type="default" @click="cancel">{{$t('global.common.cancel', { defaultValue: '取消' })}}</Button>
            </div>
		</compWrapper>
		<!-- 仓库作业费 增值服务费模板详情 包材费-->
		<compWrapper :title="getRateName" theme="primary">
			<vButtonGroup class="margin-layout" v-if="temptype==4">
				<vButton theme="primary" @click="handleOperates('add')">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
				<vButton theme="success" @click="handleOperates('import')">{{$t('global.common.import', { defaultValue: '导入' })}}</vButton>
				<vButton @click="handleOperates('export')">{{$t('global.common.export', { defaultValue: '导出' })}}</vButton>
				<vButton @click="handleOperates('delete')">{{$t('fbb.accountmanage.delete_more', { defaultValue: '批量删除' })}}</vButton>
			</vButtonGroup>
			<vButtonGroup v-else slot="footer">
				<vButton theme="primary" @click="submit">{{$t('fbb.accountmanage.save_more', { defaultValue: '批量保存' })}}</vButton>
				<vButton @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
			</vButtonGroup>
			<vTableSimple
				class="margin-layout"
				:columns="getColumns"
				:data="dataList"
				@on-check-change="handleChecked"
			></vTableSimple>
		</compWrapper>

		<!-- 弹框 -->
		<compModal
			v-model="operate.show"
			v-bind="operate"
			@on-close="operate.show=false"
			@on-confirm="getDetail"
		>
			<component
				v-if="operate.component"
				:is="operate.component"
				v-bind="operate"
				@on-close="operate={}"
				@on-update="getDetail"
				@on-success="getDetail"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpGetTemplateWarehouse, HttpSaveTemplateWarehouse, HttpGetCusLog, HttpGetTempalteStorage, HttpDelTempalteStorage, HttpCusbillTemplateList } from '@/service/billing';
import { HttpMaterialTemplate, HttpSaveMaterialTemplate, HttpSaveTransactionTemplate, HttpTransactionTemplate, HttpSaveCusTemplateCode } from '@/service/billing';
import { mapGetters } from "vuex";
import compStoragetemp from './storageTemp'

export default {
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
		compStoragetemp,
		compUpload: () => import("@components/templates/upload"),
	},
	data() {
		return {
			loading: false,
            formData: {},
            inputData: {},
			dataList: [],
			id: this.$route.query.id,
			temptype: this.$route.query.temptype,
			// type: this.$route.params.type,
			// logList: [],
			operate: {
				show: false,
				loading: false
			},
            checkedId: [],
            // formRules: {
            //     chargingUnit: {
            //         required: true,
            //         message: '此项不能为空，请填写'
            //     },
            //     minimumBillableValue: {
            //         trigger: "blur",
            //         validator: (rule, value = "", callback) => {
            //             if (!value) {
            //                 callback();
            //             } else {
            //                 if (/[0-9]*/g.test(value) && Number(value) > 0) {
            //                     callback();
            //                 } else {
            //                     callback(new Error("请输入大于0的正整数"));
            //                 }
            //             }
            //         },
            //     },
            // }
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        formRules () {
            return {
                'chargingUnit': {
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: '该信息不能为空,请填写' })
                },
                'minimumBillableValue': {
                    trigger: "blur",
                    validator: (rule, value = "", callback) => {
                        if (!value) {
                            callback();
                        } else {
                            if (/[0-9]*/g.test(value) && Number(value) > 0) {
                                callback();
                            } else {
                                callback(new Error(this.$t('fbb.accountmanage.enter_more_than_zero', { defaultValue: "请输入大于0的正整数" })));
                            }
                        }
                    },
                },
            }
        },
		getRateName(){
			const typeMap = {
				1: `(${this.$t('fbb.billing.operatefeedetail', { defaultValue: '仓库作业费' })})`,
				4: `(${this.$t('fbb.billing.storagefeedetail', { defaultValue: '仓储费' })})`,
				5: `(${this.$t('fbb.accountmanage.materiral_cost', { defaultValue: '包材费' })})`,
				3: `(${this.$t('fbb.accountmanage.more_service_cost', { defaultValue: '增值服务费' })})`
			};
			return this.$t('fbb.accountmanage.cost_setting', { defaultValue: '费率设置' })+typeMap[this.temptype]
		},
		getBase() {
			return [
				{
                    query: true,
					label: "code",
					key: "code",
				}, {
                    query: true,
					label: this.$t('fbb.accountmanage.template_name', { defaultValue: "模板名称" }),
					key: "name",
				}, {
                    show: this.temptype == 4 ? true : false,
                    query: false,
                    label: this.$t('fbb.accountmanage.cost_unit', { defaultValue: '计费单位' }),
                    key: "chargingUnit",
                    tag: 'vSelect',
                    options: [
                        {
                            label: this.$t('fbb.accountmanage.volumn_lfyc', { defaultValue: "（体积）立方英尺" }),
                            value: 1,
                        },
                        {
                            label: this.$t('fbb.accountmanage.volumn_lfm', { defaultValue: "（体积）立方米" }),
                            value: 2,
                        },
                    ],
                }, {
                    show: this.temptype == 4 ? true : false,
                    query: false,
                    label: this.$t('fbb.accountmanage.min_cost_value', { defaultValue: "最低计费值" }),
                    tag: "vInput",
                    key: "minimumBillableValue",
                }, {
                    query: true,
					label: this.$t('fbb.accountmanage_cost_currency', { defaultValue: "计费币种" }),
					key: "currency",
				}, {
                    query: true,
					label: this.$t('global.common.notes', { defaultValue: "备注" }),
					key: "remark"
				}
			];
		},
		//按照类型获取 columns
		getColumns() {
			const typeMap = {
				1: 'getWareColums',
				4: 'getStorageColumns',
				5: 'getMaterialColumns',
				3: 'getServiceColumns'
			};
			return this[typeMap[this.temptype]]
		},
		//仓库作业费模板详情
		getWareColums() {
			return [
				{
					title: "NO",
					type: 'index'
				},
				{
					title: this.$t('fbb.accountmanage.one_level_type', { defaultValue: "一级分类" }),
					key: 'firstCategoryName'
				},
				{
					title: this.$t('fbb.accountmanage.two_level_type', { defaultValue: "二级分类" }),
					key: 'secondCategoryName'
				},
				{
					title: this.$t('fbb.accountmanage.three_level_type', { defaultValue: "三级分类" }),
					key: 'thirdCategoryName'
				},
				{
					title: this.$t('fbb.billing.customerrate', { defaultValue: "客户费率" }),
					key: 'rate',
					// renderHeader: (h, params) => {
					// 	return <strong>客户费率</strong>
					// },
					render: (h, { row, index }) => {
						return h('vInput', {
							props: {
								value: row.rate
							},
							on: {
								'on-change': (val) => {
									this.$set(this.dataList[index], 'rate', val)
								}
							},
						})
					}
				},
				{
					title: this.$t('global.common.currency', { defaultValue: "币种" }),
					key: 'currency',
				},
				{
					title: this.$t('fbb.accountmanage.history_record', { defaultValue: "历史记录" }),
					render: (h, { row, index }) => {
						return <vButton theme="error" size='small' onClick={this.handleModal.bind(this, row.thirdCategoryId, 'log')}>{this.$t('fbb.accountmanage.history_record', { defaultValue: '历史记录' })}</vButton>
					}
				},
			]
		},
		//增值服务费模板详情
		getServiceColumns() {
			return [{
				title: '#',
				type: 'index',
				width: 40,
				align: 'center',
			}, {
				title: this.$t('fbb.accountmanage.deal_name', { defaultValue: '处理项名称' }),
				key: "transactionName"
			}, {
				title: this.$t('fbb.accountmanage.deal_code', { defaultValue: '处理项Code' }),
				key: 'transactionCode',
			}, {
				title: this.$t('fbb.accountmanage.cost_source', { defaultValue: '计费值来源' }),
				key: 'billingSourcesType',
				render(h, { row }) {
					return row.billingSourcesType == 'FIXED' ? this.$t('fbb.accountmanage.fixed_value', { defaultValue: '固定值' }) : this.$t('fbb.accountmanage.manual_input', { defaultValue: '手工录入' })
				}
			}, {
				title: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }),
				key: 'costValue',
				render: (h, { row, index }) => {
					const tag=row.billingSourcesType == 'FIXED'?'vInputNumber':'vInput';
					return h(tag, {
						props: {
							value: row.costValue,
							min:0
						},
						on: {
							'on-change': (val) => {
								this.$set(this.dataList[index], 'costValue', val)
							}
						}
					})
					// return <vInput onOnChage={}></vInput>
				}
			}, {
				title: this.$t('global.common.currency', { defaultValue: '币种' }),
				key: 'currency',
			}, {
				title: this.$t('fbb.accountmanage.history_record', { defaultValue: '历史记录' }),
				render: (h, { row }) => {
					return <vButton theme="error" size='small' onClick={this.handleModal.bind(this, row.id, 'log')}>{this.$t('fbb.accountmanage.history_record', { defaultValue: '历史记录' })}</vButton>
				}
			}]
		},
		//包材费
		getMaterialColumns() {
			return [{
				title: '#',
				type: 'index',
				width: 40,
				align: 'center',
			}, {
				title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
				key: "warehouseCode"
			}, {
				title: this.$t('fbb.accountmanage.material_name', { defaultValue: '包材名称' }),
				key: 'name',
			}, {
				title: this.$t('fbb.accountmanage.material_code', { defaultValue: '包材Code' }),
				key: 'materialCode',
			}, {
				title: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }),
				key: 'cost',
				render: (h, { row, index }) => {
					return h('vInputNumber', {
						props: {
							value: row.cost,
							min:0
						},
						on: {
							'on-change': (val) => {
								this.$set(this.dataList[index], 'cost', val)
							}
						}
					})
				}
			}, {
				title: this.$t('global.common.currency', { defaultValue: '币种' }),
				key: 'currency',
			}, {
				title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
				key: 'updatedAt',
			}, {
				title: this.$t('fbb.accountmanage.history_record', { defaultValue: '历史记录' }),
				render: (h, { row }) => {
					return <vButton theme="error" size='small' onClick={this.handleModal.bind(this, row.id, 'log')}>{this.$t('fbb.accountmanage.history_record', { defaultValue: '历史记录' })}</vButton>
				}
			}]
		},
		//仓储费
		getStorageColumns() {
			return [
				{
					type: 'selection',
					width: 40,
					align: 'center',
					formName: 'id'
				},
				{
					title: "NO",
					type: 'index'
				},
				{
					title: this.$t('global.common.operation', { defaultValue: "操作" }),
					render: (h, { row, index }) => {
						let { id } = row
						return <vDropdown placement="bottom-start" trigger="click">
							<vButton size='small' theme='info'>{this.$t('global.common.operation', { defaultValue: "操作" })} <vIcon type="arrow-dropdown" /></vButton>
							<template slot="list" class="text-left">
								<vDropdownItem nativeOnClick={this.handleOperates.bind(this, 'edit', id)}>{this.$t('global.common.edit', { defaultValue: '编辑' })}</vDropdownItem>
								<vDropdownItem nativeOnClick={this.handleOperates.bind(this, 'log', id)}>{this.$t('fbb.accountmanage.history_operate', { defaultValue: '历史操作' })}</vDropdownItem>
								<vDropdownItem nativeOnClick={this.handleOperates.bind(this, 'delete', id)}>{this.$t('global.common.delete', { defaultValue: '删除' })}</vDropdownItem>
							</template>
						</vDropdown >
					}
				},
				// {
				// 	title: "计费单位",
				// 	render: (h, { row }) => {
				// 		switch (row.unit) {
				// 			case 'BILL_UNIT_CUBIC_FOOT': return '立方英尺'; break;
				// 		}
				// 	}
				// },
				{
					title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
					render: (h, { row }) => {
						switch (row.inventoryType) {
							case 'CAN_SALE': return this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }); break;
							case 'NO_SALE': return this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }); break;
						}
					}
				},
				{
					title: this.$t('fbb.accountmanage.save_day_start', { defaultValue: "存储天数（起）" }),
					key: 'storageStart'
				},
				{
					title: this.$t('fbb.accountmanage.save_day_end', { defaultValue: "存储天数（止）" }),
					key: 'storageEnd'
				},
				{
					title: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }),
					key: 'rate'
				},
				{
					title: this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency',
				},
				{
					title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
					key: 'updatedAt',
				},

			]
		},
		getLogColums() {
			return [
				{
					title: "NO",
					type: 'index'
				},
				{
					title: this.$t('fbb.accountmanage.param', { defaultValue: "字段" }),
					render:(h,{row})=>{
						switch(row.field){
							case 'inventoryType': return this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }); break;
							case 'storageStart': return this.$t('fbb.accountmanage.save_start_days', { defaultValue: '储存起始天数' }); break;
							case 'storageEnd': return this.$t('fbb.accountmanage.save_end_days', { defaultValue: '储存结束天数' }); break;
							case 'rate': return this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }); break;
						}
					}
				},
				{
					title: this.$t('fbb.accountmanage.before_change', { defaultValue: "修改前" }),
					key: 'beforeValue'
				},
				{
					title: this.$t('fbb.accountmanage.after_change', { defaultValue: "修改后" }),
					key: 'afterValue'
				},
				{
					title: this.$t('global.common.operator', { defaultValue: "操作人" }),
					key: 'updatedName'
				},
				{
					title: this.$t('global.common.operate_time', { defaultValue: "操作时间" }),
					key: 'updatedAt',
				},
			]
		}
	},
	methods: {
        async saveOne () {
            let flag = true;
            await this.$refs.saveForm.validate(valid => {
                flag = valid;
            });
            if (!flag) return;
            // return console.log(this.inputData);
            let { minimumBillableValue, chargingUnit, ...requestData } = {
                ...this.inputData
            }
            let meta = JSON.stringify({
                minimumBillableValue,
                chargingUnit
            })
            HttpSaveCusTemplateCode({
                id: this.id,
                organizationId: global.SYSID,
                type: this.temptype,
                ...requestData,
                meta
            }).then(res => {
                this.$Message.success(res.message);
            }, err => {
                this.$Message.error(err.message);
            })
        },
		handleModal(data, type) {
			if (type === 'log') {
				// templateId: this.id,
				// itemId: thirdCategoryId
				this.operate = {
					show: true,
					width: 'normal',
					component: 'compLog',
					title: this.$t('fbb.accountmanage.history_record', { defaultValue: '历史记录' }),
					showFooter: false,
					ajaxRequest: HttpGetCusLog,
					params: {
						templateId: this.id,
						itemId: data
					},
					columns: this.getLogColums
				}
				return;
			}
		},
		handleChecked(rows, val) {
			this.checkedId = val;
		},
		handleOperates(type, data) {
			switch (type) {
				case 'add':
					this.operate = {
						title: this.$t('global.common.add', { defaultValue: '添加' }),
						show: true,
						width: 'middle',
						operatype: 'add',
						component: "compStoragetemp",
						showFooter: false,
					}
					break;
				case 'edit':
					this.operate = {
						title: this.$t('global.common.edit', { defaultValue: '编辑' }),
						show: true,
						activeids: data,
						width: 'middle',
						operatype: 'edit',
						component: "compStoragetemp",
						showFooter: false,
					}
					break;
				case 'export':
					this.handleWebfs(
						process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouseStorage/exportInfo", { templateId: this.id },
						"download"
					);
					break;
				case 'import':
					this.operate = {
						show: true,
						title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
						width: 460,
						showFooter: false,
						data: { templateId: this.id },
						action: process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouseStorage/importInfo",
						name: "excelFile",
						component: "compUpload",
						download: () => {
							this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouseStorage/warehouseStorageTemplate", {}, 'download')
						},
					}
					break
				case 'log': this.handleModal(data, 'log'); break;
				case 'delete':
					this.checkedId = !data ? this.checkedId : [data];
					if (this.checkedId.length == 0) {
						this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
						return;
					}
					this.operate = {
						show: true,
						alert: "error",
						params: { ids: this.checkedId },
						title: this.$t('global.common.delete', { defaultValue: "删除" }),
						ajaxRequest: HttpDelTempalteStorage
					}
					break;

			}
		},
		getDetail() {
			this.operate={};
			this.loading = false;
			HttpCusbillTemplateList({
				page: 1,
				rows: 1,
				// sidx: 'id',
				// sord: 'desc',
				'search[EQ_id]': this.id,
			}).then(res => {
                console.log(res.data);
                this.formData = res.data.content[0];
                let meta = this.formData.meta ? JSON.parse(this.formData.meta) : {};
                this.inputData = {
                    code: this.formData.code,
                    name: this.formData.name,
                    remark: this.formData.remark,
                    currency: this.formData.currency,
                    chargingUnit: meta.chargingUnit,
                    minimumBillableValue: meta.minimumBillableValue
                }
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
			this.getRateDetail();
		},
		// 获取费率模板
		getRateDetail() {
			let ajax, temptype = this.temptype;
			if (temptype == 4) ajax = HttpGetTempalteStorage;
			if (temptype == 1) ajax = HttpGetTemplateWarehouse;
			if (temptype == 5) ajax = HttpMaterialTemplate;
			if (temptype == 3) ajax = HttpTransactionTemplate;
			if (!ajax) return;
			this.loading = true;
			ajax({ type: this.temptype, templateId: this.id }).then(res => {
				this.dataList = res.data.templateItems;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//包材模板保存
		submitMaterial() {
			this.loading = true;
			HttpSaveMaterialTemplate({ billingTemplateId: this.id, packageMaterialTempItems: this.dataList }).then(res => {
                this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: "操作成功" }));
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//事务项模板保存
		submitService() {
			this.loading = true;
			HttpSaveTransactionTemplate({ billingTemplateId: this.id, processedTransactionTempItems: this.dataList }).then(res => {
                this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: "操作成功" }));
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},

		//仓库作业费模板保存
		submitWarehouse() {
			this.loading = true;
			HttpSaveTemplateWarehouse({ billingTemplateId: this.id, warehouseOperationTempItems: this.dataList }).then(res => {
                this.$VMessage.success(this.$t('erp.managewarehouse.operate_success', { defaultValue: "操作成功" }));
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		submit() {
			const typeMap = {
				1: 'submitWarehouse',
				5: 'submitMaterial',
				3: 'submitService'
			};
			const ajax = typeMap[this.temptype];
			if (ajax) this[ajax]();
		},
		cancel() {
			this.$router.push({ name: 'customerRateTemplatelist' });
		},
	}
};
</script>
